export enum ServerErrorMessage {
  innInUse = 'developer.form.error.innInUse',
  ownerPhoneInUse = 'developer.form.error.ownerPhoneInUse',
  ownerEmailInUse = 'developer.form.error.ownerEmailInUse',
}
